import { useTenant } from "../../Contexts/TenantContext";
import { useAuth } from "../../Contexts/AuthContext";
import Navbar from "../Navbar/Navbar";
import AltNavbar from "../AltNavbar/AltNavbar";
import AltAdminNavbar from "../AltAdminNavbar/AltAdminNavbar";

const SmartNavbar = () => {
  const { tenantPreference } = useTenant();
  const { isAdmin, isOperator } = useAuth();

  if (tenantPreference?.enableAltHomeLayout) {
    return (isAdmin || isOperator) ? <AltAdminNavbar /> : <AltNavbar />;
  }

  return <Navbar />;
};

export default SmartNavbar;
